"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "applyMacros", {
  enumerable: true,
  get: function get() {
    return _hasConfigMacro.applyMacros;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "getMacroKey", {
  enumerable: true,
  get: function get() {
    return _hasConfigMacro.getMacroKey;
  }
});

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.function.name.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _startCase2 = _interopRequireDefault(require("lodash/startCase"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _assign2 = _interopRequireDefault(require("lodash/assign"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactAccessibility = require("@nerdwallet/react-accessibility");

var _num = _interopRequireDefault(require("@nerdwallet/nw-client-lib/num"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _currency = require("@nerdwallet/currency");

var _legacy = _interopRequireDefault(require("@nerdwallet/react-formatted-input/dist/legacy"));

var _reactStepper = _interopRequireWildcard(require("@nerdwallet/react-stepper"));

var _hasConfigMacro = require("./has-config-macro");

var _trackInputField2 = _interopRequireDefault(require("./track-input-field"));

var _excluded = ["customComponents"],
    _excluded2 = ["id"];

var _trackInputField = (0, _trackInputField2.default)(),
    INPUT_TYPES = _trackInputField.INPUT_TYPES,
    trackInputChange = _trackInputField.trackInputChange;
/* eslint-disable react/prop-types, react/no-danger */


var ValidationFeedback = function ValidationFeedback(_ref) {
  var feedback = _ref.feedback;
  return /*#__PURE__*/_react.default.createElement("span", null, feedback.map(function (string) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: string,
      dangerouslySetInnerHTML: {
        __html: string
      }
    });
  }));
};
/* eslint-enable react/prop-types, react/no-danger */


var ConfigBuilder = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ConfigBuilder, _Component);

  var _super = (0, _createSuper2.default)(ConfigBuilder);

  function ConfigBuilder() {
    (0, _classCallCheck2.default)(this, ConfigBuilder);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ConfigBuilder, [{
    key: "onBlur",
    value: function onBlur(config, e) {
      var eventValue = this.getEventValue(config, e); // Track input form changes

      this.processTracking(config, e, eventValue); // Do we have a custom onBlur?

      if (typeof this.props.onBlur === 'function') {
        this.props.onBlur(config, eventValue);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(config, e) {
      var eventValue = this.getEventValue(config, e); // Do not track input and textarea types, these get tracked on onblur

      if (config.viewType !== 'input' && config.viewType !== 'textarea') {
        // Track input form changes
        this.processTracking(config, e, eventValue);
      } // Do we have a custom onChange?


      if (typeof this.props.onChange === 'function') {
        this.props.onChange(config, eventValue);
      }
    }
  }, {
    key: "getEventValue",
    value: function getEventValue(config, e) {
      switch (config.viewType) {
        case 'slider':
        case 'stepper':
          return e;

        case 'textarea':
        case 'radio':
        case 'checkbox':
        case 'select':
          return e.target.value;

        default:
          {
            var value = e.target.value;

            if (config.formatType === 'phoneNumber') {
              // remove non-digits
              return value === '' ? '' : value.replace(/\D/g, '');
            } // eslint-disable-next-line no-nested-ternary


            return config.subType === 'text' || config.formatType === 'date' ? value : value === '' ? '' : _num.default.value(value);
          }
      }
    }
  }, {
    key: "getTrackingInputType",
    value: function getTrackingInputType(config) {
      switch (config.viewType) {
        case 'radio':
        case 'select':
        case 'slider':
        case 'stepper':
          return INPUT_TYPES.RANGE;

        case 'textarea':
        default:
          return INPUT_TYPES.TEXT;
      }
    }
  }, {
    key: "getValidation",
    value: function getValidation(config, rawConfig) {
      // Is the validation config dynamically populated?
      if (typeof config.getValidationConfig === 'function') {
        // Apply the configuration returned from the function...
        return config.getValidationConfig(this.props.data, config, rawConfig);
      }

      if (config.validation) {
        return {
          isValid: config.value === undefined || config.value >= config.min && config.value <= config.max
        };
      }

      return undefined;
    }
  }, {
    key: "getValidationProps",
    value: function getValidationProps(config, rawConfig) {
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help;

      if (feedback && feedback.length > 0) {
        help = /*#__PURE__*/_react.default.createElement(ValidationFeedback, {
          feedback: feedback
        });
      }

      return {
        error: error,
        help: help
      };
    }
  }, {
    key: "processTracking",
    value: function processTracking(config, e, eventValue) {
      // Track input form changes
      if (this.props.enableTracking) {
        trackInputChange({
          fieldName: config.trackingFieldName || (0, _hasConfigMacro.getMacroKey)(config, 'value'),
          fieldValue: config.trackingRedactValue ? '' : "".concat(eventValue),
          inputType: this.getTrackingInputType(config),
          formName: this.props.formName
        });
      }
    }
  }, {
    key: "renderPercentageInput",
    value: function renderPercentageInput(config, rawConfig) {
      var eventConfig = (0, _assign2.default)({}, rawConfig, {
        viewType: 'percentage'
      });
      var value = (0, _isEmpty2.default)(config.value) ? '' : _num.default.formatPercent(config.value, config.formatMask);
      var placeholder = config.skipFormatPlaceholder || (0, _isEmpty2.default)(config.placeholder) ? config.placeholder : _num.default.formatPercent(config.placeholder, config.formatMask);
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help;

      if (feedback && feedback.length > 0) {
        help = /*#__PURE__*/_react.default.createElement(ValidationFeedback, {
          feedback: feedback
        });
      }

      var props = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _pick2.default)(config, ['autoFocus', 'type'])), {}, {
        decimalScale: 3,
        suffix: '%',
        allowNegative: config.allowNegative !== undefined ? config.allowNegative : false,
        value: value,
        placeholder: placeholder,
        error: error,
        fullWidth: true,
        onBlur: this.onBlur.bind(this, eventConfig),
        onChange: this.onChange.bind(this, eventConfig),
        onFocus: this.props.onFocus,
        onKeyPress: this.props.onKeyPress,
        id: "".concat(this.props.id, "-pct-input")
      });

      var input = /*#__PURE__*/_react.default.createElement("span", {
        className: "nw-cfg-input-width"
      }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, (0, _extends2.default)({
        customInput: _currency.Input
      }, props)));

      if (config.isInline) {
        return input;
      }

      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: input,
        inputId: props.id,
        error: error,
        errorMessage: help,
        tooltip: config.help
      });
    }
  }, {
    key: "renderInput",
    value: function renderInput(config, rawConfig) {
      var eventConfig = (0, _assign2.default)({}, rawConfig, {
        viewType: 'input'
      });
      var placeholder = config.placeholder,
          value = config.value;
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help;

      if (feedback && feedback.length > 0) {
        help = /*#__PURE__*/_react.default.createElement(ValidationFeedback, {
          feedback: feedback
        });
      }

      var props = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _pick2.default)(config, ['autoFocus', 'disabled', 'maxLength', 'placeholder', 'type', 'value', 'name'])), {}, {
        fullWidth: true,
        error: error,
        onBlur: this.onBlur.bind(this, eventConfig),
        onChange: this.onChange.bind(this, eventConfig),
        onFocus: this.props.onFocus,
        onKeyPress: this.props.onKeyPress,
        id: "".concat(this.props.id, "-input")
      });
      var input;

      if (config.formatType === 'none') {
        input = /*#__PURE__*/_react.default.createElement("span", {
          className: "nw-cfg-input-width"
        }, /*#__PURE__*/_react.default.createElement(_currency.Input, props));
      } else if (config.formatType === 'phoneNumber') {
        var formatProps = {
          format: config.formatPattern || '(###) ###-####'
        };
        input = /*#__PURE__*/_react.default.createElement("span", {
          className: "nw-cfg-input-width"
        }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, (0, _extends2.default)({
          customInput: _currency.Input
        }, props, formatProps)));
      } else if (config.formatType === 'ssn' || config.formatType === 'pattern' || config.formatType === 'alphabet') {
        var _formatProps = (0, _pick2.default)(config, ['formatType', 'formatMask', 'formatPattern', 'formatTriggerEvent', 'skipFormatPlaceholder']);

        input = /*#__PURE__*/_react.default.createElement("span", {
          className: "nw-cfg-input-width"
        }, /*#__PURE__*/_react.default.createElement(_legacy.default, (0, _extends2.default)({}, props, _formatProps)));
      } else if (config.formatType === 'number') {
        input = /*#__PURE__*/_react.default.createElement("span", {
          className: "nw-cfg-input-width"
        }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, (0, _extends2.default)({
          customInput: _currency.Input
        }, props)));
      } else {
        var isCurrency = config.formatType === 'currency' || !config.formatType;
        var numberFormatProps = {
          prefix: isCurrency ? '$' : '',
          decimalScale: isCurrency ? 0 : undefined,
          thousandSeparator: true,
          // ConfigBuilder always converts mapped values to strings, so parse it first ONLY if its not an empty string (no value)
          // would otherwise be set to $0 when given no value
          value: value !== '' ? _num.default.value(value) : '',
          allowNegative: config.allowNegative !== undefined ? config.allowNegative : false,
          placeholder: isCurrency && !config.skipFormatPlaceholder ? _num.default.formatCurrency(_num.default.value(placeholder)) : placeholder
        };
        input = /*#__PURE__*/_react.default.createElement("span", {
          className: "nw-cfg-input-width"
        }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, (0, _extends2.default)({
          customInput: _currency.Input
        }, props, numberFormatProps)));
      }

      if (config.isInline) {
        return input;
      }

      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: input,
        inputId: props.id,
        error: error,
        errorMessage: help,
        tooltip: config.help
      });
    }
  }, {
    key: "renderStepper",
    value: function renderStepper(config, rawConfig) {
      var _this = this;

      var value = config.value;
      var props = {
        onChange: this.onChange.bind(this, (0, _assign2.default)({}, rawConfig, {
          viewType: 'stepper'
        })),
        value: _num.default.value(value),
        id: "".concat(this.props.id, "-stepper")
      };
      var input;

      if (config.subType === 'number') {
        var formatFn = (0, _isFunction2.default)(config.formatFn) ? config.formatFn : config.formatType && function (val) {
          return _num.default["format".concat((0, _startCase2.default)(config.formatType))](val);
        };
        props = (0, _assign2.default)(props, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _omit2.default)(config, ['value'])), {}, {
          formatFn: formatFn
        }));
        (0, _forEach2.default)(['min', 'max'], function (propName) {
          // If we have functions for min and max - invoke them now.
          if ((0, _isFunction2.default)(props[propName])) {
            props[propName] = props[propName](_this.props);
          }
        });
        input = /*#__PURE__*/_react.default.createElement(_reactStepper.NumStepper, props);
      } else {
        props = (0, _assign2.default)(props, (0, _objectSpread2.default)({}, (0, _pick2.default)(config, ['range'])));
        input = /*#__PURE__*/_react.default.createElement(_reactStepper.default, props);
      }

      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: input,
        inputId: props.id,
        tooltip: config.help
      });
    }
  }, {
    key: "renderSelect",
    value: function renderSelect(config, rawConfig) {
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help;

      if (feedback && feedback.length > 0) {
        help = /*#__PURE__*/_react.default.createElement(ValidationFeedback, {
          feedback: feedback
        });
      }

      var props = {
        error: error,
        autoFocus: config.autoFocus,
        block: true,
        multiple: !!config.multiple,
        fullWidth: !!config.multiple,
        onChange: this.onChange.bind(this, (0, _assign2.default)({}, rawConfig, {
          viewType: 'select'
        })),
        options: (0, _map2.default)(rawConfig.items, function (_ref2) {
          var label = _ref2.label,
              value = _ref2.value,
              disabled = _ref2.disabled;
          return {
            label: label,
            value: value,
            disabled: disabled
          };
        }),
        id: "".concat(this.props.id, "-select")
      }; // value will block defaultValue even if its an empty string
      // TODO can this be === ''?
      // eslint-disable-next-line eqeqeq

      if (config.defaultValue && config.value == '') {
        props.defaultValue = config.defaultValue;
      } else {
        props.value = config.value;
      }

      var input = /*#__PURE__*/_react.default.createElement("span", {
        className: "nw-cfg-input-width"
      }, /*#__PURE__*/_react.default.createElement(_currency.Select, props));

      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: input,
        inputId: props.id,
        error: error,
        errorMessage: help,
        tooltip: config.help
      });
    }
  }, {
    key: "renderRadio",
    value: function renderRadio(config, rawConfig) {
      var validation = this.getValidationProps(config, rawConfig);
      var options = (0, _map2.default)(rawConfig.items, function (_ref3) {
        var label = _ref3.label,
            value = _ref3.value;
        return {
          label: label,
          value: String(value)
        };
      });
      var props = {
        defaultValue: !config.noDefaultChecked && config.defaultValue,
        inline: config.inline,
        name: config.name,
        onChange: this.onChange.bind(this, (0, _assign2.default)({}, rawConfig, {
          viewType: 'radio'
        })),
        options: options,
        value: config.value,
        id: "".concat(this.props.id, "-radio")
      };

      var input = /*#__PURE__*/_react.default.createElement(_currency.RadioGroup, props);

      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: input,
        inputId: props.id,
        error: validation.error,
        help: validation.help,
        tooltip: config.help
      });
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox(config, rawConfig) {
      var eventConfig = (0, _assign2.default)({}, rawConfig, {
        viewType: 'checkbox'
      });
      var name = config.name,
          value = config.value,
          readOnly = config.readOnly,
          disabled = config.disabled,
          defaultValue = config.defaultValue,
          inline = config.inline;
      var options = rawConfig.options;
      var props = {
        disabled: disabled,
        options: options,
        readOnly: readOnly,
        value: value,
        name: name,
        inline: inline,
        defaultValue: defaultValue,
        onChange: this.onChange.bind(this, eventConfig),
        id: "".concat(this.props.id, "-checkbox")
      };
      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: /*#__PURE__*/_react.default.createElement(_currency.CheckboxGroup, props),
        inputId: props.id,
        tooltip: config.help
      });
    }
  }, {
    key: "renderTextarea",
    value: function renderTextarea(config, rawConfig) {
      var validation = this.getValidation(config, rawConfig);
      var error = validation && !validation.isValid;
      var feedback = validation && validation.feedback;
      var help;

      if (feedback && feedback.length > 0) {
        help = /*#__PURE__*/_react.default.createElement(ValidationFeedback, {
          feedback: feedback
        });
      }

      var props = {
        placeholder: config.placeholder,
        value: config.value,
        fullWidth: true,
        error: error,
        onBlur: this.onBlur.bind(this, rawConfig),
        onChange: this.onChange.bind(this, rawConfig),
        id: "".concat(this.props.id, "-textarea")
      };
      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: /*#__PURE__*/_react.default.createElement(_currency.Textarea, props),
        inputId: props.id,
        error: error,
        errorMessage: help,
        tooltip: config.help
      });
    }
  }, {
    key: "renderCustomComponent",
    value: function renderCustomComponent(config, rawConfig) {
      var _this$props = this.props,
          CustomComponent = _this$props.customComponents[rawConfig.componentName],
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      props.id = "".concat(this.props.id, "-input-nw-cfg-builder-input");
      var renderedComponent = CustomComponent(props);

      if (rawConfig.isNotInput) {
        return renderedComponent;
      }

      return /*#__PURE__*/_react.default.createElement(_currency.InputGroup, {
        label: config.label,
        input: renderedComponent,
        inputId: props.id,
        tooltip: config.help
      });
    }
  }, {
    key: "renderText",
    value: function renderText(config) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "nw-cfg-input-text"
      }, config.label, config.help && /*#__PURE__*/_react.default.createElement(_currency.HelpBubble, {
        id: "".concat(this.props.id, "-text-help-bubble"),
        content: config.help,
        title: "More information about ".concat(config.label),
        placement: "top"
      }));
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage(config) {
      var errorMessage = config.getErrorMessage && config.getErrorMessage(this.props.data) || {};
      var classes = (0, _classnames.default)('nw-cfg-builder-error', {
        open: !(0, _isEmpty2.default)(errorMessage)
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "error-title"
      }, errorMessage.title), /*#__PURE__*/_react.default.createElement("p", null, errorMessage.message));
    }
  }, {
    key: "renderContentText",
    value: function renderContentText(config) {
      return (0, _map2.default)(config.text, function (text, index) {
        return /*#__PURE__*/_react.default.createElement("p", {
          key: "text".concat(index)
        }, text);
      });
    }
  }, {
    key: "renderContentComponent",
    value: function renderContentComponent(config, rawConfig) {
      switch (rawConfig.viewType) {
        case 'checkbox':
          return this.renderCheckbox(config, rawConfig);

        case 'custom':
          return this.renderCustomComponent(config, rawConfig);

        case 'input':
          return this.renderInput(config, rawConfig);

        case 'radio':
          return this.renderRadio(config, rawConfig);

        case 'percentage':
          return this.renderPercentageInput(config, rawConfig);

        case 'select':
          return this.renderSelect(config, rawConfig);

        case 'stepper':
          return this.renderStepper(config, rawConfig);

        case 'textarea':
          return this.renderTextarea(config, rawConfig);

        case 'text':
          return this.renderText(config, rawConfig);

        default: // Do nothing.

      }

      return null;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props2 = this.props,
          viewConfig = _this$props2.viewConfig,
          titleClass = _this$props2.titleClass;

      if (viewConfig.title !== undefined) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(titleClass, " nw-cfg-builder-title")
        }, viewConfig.title, viewConfig.titleHelp && /*#__PURE__*/_react.default.createElement(_currency.HelpBubble, {
          id: "".concat(this.props.id, "-title-help-bubble"),
          content: viewConfig.titleHelp,
          placement: "top",
          title: "More information about ".concat(viewConfig.title)
        }));
      }

      return null;
    }
  }, {
    key: "renderImage",
    value: function renderImage(_ref4) {
      var imgURL = _ref4.imgURL,
          imgWidth = _ref4.imgWidth,
          imgHeight = _ref4.imgHeight;
      var sizeProps = {};

      if (imgWidth && imgHeight) {
        sizeProps = {
          width: String(imgWidth),
          height: String(imgHeight)
        };
      }

      if (imgURL) {
        return /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
          className: "nw-cfg-builder-img",
          alt: "",
          src: imgURL
        }, sizeProps));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          viewConfig = _this$props3.viewConfig;
      var config = (0, _hasConfigMacro.applyMacros)(viewConfig, this.props.data);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('nw-cfg-builder-v6', className, viewConfig.className, viewConfig.key)
      }, this.renderImage(viewConfig), this.renderTitle(), this.renderContentText(config), this.renderContentComponent(config, viewConfig), this.renderErrorMessage(config, viewConfig));
    }
  }]);
  return ConfigBuilder;
}(_react.Component); // use an autogenerated id as prefix for ids created for all sub-renders


(0, _defineProperty2.default)(ConfigBuilder, "displayName", 'ConfigBuilder');
(0, _defineProperty2.default)(ConfigBuilder, "propTypes", {
  /**
   * className to apply to root `div`
   */
  className: _propTypes.default.string,

  /**
   * Whether to enable FORM_INPUT_CHANGED events.
   * @default true
   */
  enableTracking: _propTypes.default.bool,

  /**
   * formName supplied to FORM_INPUT_CHANGED
   * @default 'config-builder'
   */
  formName: _propTypes.default.string,

  /**
   * Autogenerated ID created by the exported wrapping component ConfigBuilderWithId
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Called when input loses focus, receives `viewConfig, eventValue`
   */
  onBlur: _propTypes.default.func,

  /**
   * Called when an input changes, receives `viewConfig, eventValue`
   */
  onChange: _propTypes.default.func,

  /**
   * Called when input gains focus, receives `event`
   */
  onFocus: _propTypes.default.func,

  /**
   * Invoked onKeyPress of component, receives `event`
   */
  onKeyPress: _propTypes.default.func,

  /**
   * Object of references to custom components, key should match `componentName`
   * in `viewConfig`
   */
  customComponents: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * Arbitrary object of data that is passed to various callbacks
   */
  data: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * className to apply to `title`
   */
  titleClass: _propTypes.default.string,

  /**
   * The config for the underlying component
   */
  viewConfig: _propTypes.default.shape({
    // All components
    viewType: _propTypes.default.oneOf(['checkbox', 'custom', 'input', 'percentage', 'radio', 'select', 'stepper', 'text', 'textarea']).isRequired,

    /**
     * Arbitrary text inserted above the input component, wrapped around a `<p>`.
     */
    text: _propTypes.default.arrayOf(_propTypes.default.node),

    /**
     * Arbitrary text inserted above the input component, wrapped around a `<div>`.
     * @deprecated
     */
    title: _propTypes.default.string,

    /**
     * Arbitrary text passed along to `<HelpBubble>`.
     * @deprecated
     */
    titleHelp: _propTypes.default.string,

    /**
     * Stepper only. Either `'number'` or not.
     */
    subType: _propTypes.default.string,

    /**
     * fieldName of FORM_INPUT_CHANGED
     */
    trackingFieldName: _propTypes.default.string,

    /**
     * Redacts field value from FORM_INPUT_CHANGED if true
     */
    trackingRedactValue: _propTypes.default.bool,

    /**
     * Specify options for Radios, Checkboxes, Select
     */
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]).isRequired,
      disabled: _propTypes.default.bool
    })),

    /**
     * Used to determine the type of formatting applied to the input.
     * Below are known types but this isn't the full list.
     *
     * alphabet: restricts to only alphabet[a-z,A-Z] input only, using FormattedInput see (https://github.com/NerdWallet/react-components/tree/master/components/formatted-input)
     * none: no formatting applied
     * number: restricts to only numeric input only, using FormattedInput see (https://github.com/NerdWallet/react-components/tree/master/components/formatted-input)
     * pattern: using FormattedInput see (https://github.com/NerdWallet/react-components/tree/master/components/formatted-input)
     * ssn: using FormattedInput see (https://github.com/NerdWallet/react-components/tree/master/components/formatted-input)
     * currency: using NumberFormat
     */
    formatType: _propTypes.default.string,

    /**
     * skipFormatPlaceholder controls whether or not input value formatting is applied to placeholder value.
     * if skipFormatPlaceholder is:
     *   true: don't apply input value formatting to placeholder
     *   false: apply input value formatting to placeholder, this is the default if not specified
     */
    skipFormatPlaceholder: _propTypes.default.bool,

    /**
     * Used for non-number stepper
     */
    range: _propTypes.default.arrayOf(_propTypes.default.shape({
      name: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    })),

    /**
     * Specify options for Radio, Select
     */
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]).isRequired
    })),

    /**
     * Renders a HelpBubble. Passed to `InputGroup` as `tooltip`.
     */
    help: _propTypes.default.string,

    /**
     * The label of an input.  Consider this required if this renders an input.
     */
    label: _propTypes.default.string,

    /**
     * URL of an image to insert above input.
     */
    imgURL: _propTypes.default.string,

    /**
     * Image Width size.
     */
    imgWidth: _propTypes.default.number,

    /**
     * Image Height size.
     */
    imgHeight: _propTypes.default.number,

    /**
     * For `viewType=custom` components, the name of the component as
     * defined by `props.customComponents`
     */
    componentName: _propTypes.default.string,

    /**
     * Arbitrary object that won't be passed to component
     * Useful for passing data to an `onChange` for instance.
     */
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    config: _propTypes.default.object,

    /**
     * Callback for specifying an error message, should return an object
     * with a signature of `{ title: String, message: String }`
     * Receives `props.data` as sole argument
     * @deprecated
     */
    getErrorMessage: _propTypes.default.func,

    /**
     * Callback for specifying an error message, should return an object
     * with a signature of `{ isValid: Boolean, feedback: [String] }`
     * Receives `props.data, config, rawConfig` as arguments
     */
    getValidationConfig: _propTypes.default.func,

    /**
     * Legacy method of validation, if truthy, checks `value` against `undefined`
     * and `min` and `max` props.
     * Will not work if `min` and `max` are functions
     * @deprecated
     */
    validation: _propTypes.default.bool,

    /**
     * Minimum value, only used for `NumStepper` and legacy validation
     */
    min: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),

    /**
     * Maximum value, only used for `NumStepper` and legacy validation
     */
    max: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),

    /**
     * Select only. Boolean to determine if select should be multiselect
     */
    multiple: _propTypes.default.bool,

    /**
     * "Macro" keys.
     */
    keys: _propTypes.default.arrayOf(_propTypes.default.shape({
      /**
       * Defines the path to the desired value
       * `_.get(props.data, props.viewConfig.key)`
       */
      key: _propTypes.default.string,

      /**
       * Optionally pass in all of `data` to this function instead of specifying a key
       */
      getValue: _propTypes.default.func,

      /**
       * Optionally run through either formatCurrency or formatPercent from
       * @nerdwallet/nw-client-lib/num
       */
      type: _propTypes.default.oneOf(['currency', 'percent']),

      /**
       * If currency, this means should include cents, if percent, defines
       * the "formatterString" as passed to `numeral` library
       */
      formatterStr: _propTypes.default.string
    }))
  })
});
(0, _defineProperty2.default)(ConfigBuilder, "defaultProps", {
  customComponents: {},
  enableTracking: true,
  formName: 'config-builder'
});

var ConfigBuilderWithId = function ConfigBuilderWithId(_ref5) {
  var idProp = _ref5.id,
      props = (0, _objectWithoutProperties2.default)(_ref5, _excluded2);
  var id = (0, _reactAccessibility.useId)(idProp);
  return /*#__PURE__*/_react.default.createElement(ConfigBuilder, (0, _extends2.default)({}, props, {
    id: id
  }));
};

ConfigBuilderWithId.propTypes = ConfigBuilder.propTypes; // eslint-disable-line react/static-property-placement

var _default = ConfigBuilderWithId;
exports.default = _default;